export const DIRECTIONS = Object.freeze({
  Up: "up",
  Down: "down",
  Left: "left",
  Right: "right",
});

export const KEY_BIND = Object.freeze({
  38: DIRECTIONS.Up,
  40: DIRECTIONS.Down,
  37: DIRECTIONS.Left,
  39: DIRECTIONS.Right,
});

export const SPACE_BAR_CODE = 32;
